import elementLocale from 'element-ui/lib/locale/lang/en'

export default {
  ...elementLocale,
  menu: {
    home: 'Home',
    product: 'Products',
    news: 'News & Resources',
    about: 'About Us',
    contact: 'Contact',
    case: 'Case Studies',
    assess: 'Industrial Assessment'
  },
  hero: {
    title: "Inclusive intelligent innovation, abundant and sustainable future",
    subtitle: "Accelerate the realization of net-zero carbon emissions, provide innovative intelligent solutions for various industries",
    exploreBtn: 'Explore Products',
    contactBtn: 'Contact Us',
    tag1: 'Cement Industry',
    tag2: 'Petrochemical Industry',
    tag3: 'Steel Industry',
    product1: 'Equipment Safety Anomaly Alerts',
    product2: 'Real-time Quality Prediction',
    product3: 'Process Parameter Optimisation',
    product4: 'Eco Intelligent Butler'
  },
  siteName: 'Grand Founts AI Official Website',
  siteDescription: 'Accelerate net-zero carbon emissions, provide innovative intelligent solutions for various industries',

  // ===== Home sections =====
  home: {
    keywords: 'AI technology, Grand Founts, Grand Founts AI Technology Shandong, heavy industry AI, intelligent solutions',
    about: {
      title: 'Grand Founts AI',
      titleSpan: 'Technology (Shandong) Co., Ltd.',
      desc: 'Focused on the deep integration of AI in heavy industry, with a core mission of advancing ESG development, committed to helping enterprises achieve net-zero carbon emissions and environmental sustainability.',
      feat1Title: 'Intelligent Solutions',
      feat1Text: 'Covering cement, petrochemicals, steel and other high-energy sectors, providing integrated services from production optimisation to precise carbon emission control.',
      feat2Title: 'Environmental Service Chain',
      feat2Text: 'Providing one-stop environmental solutions including industrial filter bag R&D, intelligent environmental management, forming a dual-drive service system of smart technology and eco equipment.',
      en: '广丰人工智能科技（山东）有限公司 — 通过智能创新加速实现净零碳排放。'
    },
    products: {
      title: 'Empowering Enterprises with',
      titleSpan: 'Intelligent Manufacturing',
      sub: 'Accelerating ESG development in heavy industry to achieve net zero carbon emissions and environmental sustainability',
      viewDetail: 'View Details →',
      learnMore: 'Learn More'
    },
    scene: {
      title: 'Application',
      titleSpan: 'Scenarios'
    },
    news: {
      title: 'News &',
      titleSpan: 'Updates',
      readMore: 'Read More'
    },
    honor: {
      title: 'Honours &',
      titleSpan: 'Accreditations'
    },
    contact: {
      title: 'Contact',
      titleSpan: 'Us',
      tel: 'Phone',
      hours: 'Business Hours',
      hoursValue: 'Mon–Fri 08:30–12:00, 13:00–17:30',
      address: 'Address',
      addressValue: 'Room 608, 6F, Building 11, Ke Chuang Yuan, Yantai Road 99, Rizhao, Shandong, China'
    },
    footer: {
      legal: 'Legal Notice',
      privacy: 'Privacy Policy',
      personalInfo: 'Personal Data Protection',
      sitemap: 'Sitemap'
    }
  },

  // ===== Case list =====
  case: {
    pageTitle: 'Case Studies'
  },

  // ===== Case detail =====
  caseDetail: {
    intro: 'Case Overview',
    process: 'Core Process',
    detail: 'Detailed Description'
  },

  // ===== News list =====
  news: {
    pageTitle: 'News Center'
  },

  // ===== News detail =====
  newsDetail: {
    pageTitle: 'News Detail',
    rizhaoLink: 'Rizhao News Interview Video',
    qiluLink: 'Qilu Evening News Interview'
  },

  // ===== Product page =====
  product: {
    currentStatus: 'Current Status',
    painPoints: 'Pain Points',
    solution: 'Solutions',
    realApp: 'Real Applications',
    benefits: 'Benefits Achieved',
    ecoButler: 'Environmentally Friendly Intelligent Butler',
    filterMedia: 'Filter Media',
    filterCloth: 'Filter Cloth',
    filterCartridge: 'Filter Cartridge'
  },

  // ===== About page =====
  about: {
    pageTitle: 'Company Profile',
    positioning: 'Company Positioning',
    positioningText: 'Grand Founts Artificial Intelligence Technology (Shandong) Co., Ltd. is a high-tech enterprise introduced as a key project in Rizhao High-Tech Zone. The company focuses on the deep integration of artificial intelligence within heavy industry, with its core mission centred on advancing ESG (Environmental, Social and Governance) development. Through technological innovation, it is committed to helping enterprises achieve net zero carbon emissions and long-term environmental sustainability.',
    coreBiz: 'Core Business: Intelligent Solutions for Heavy Industry',
    coreBizText: 'The company is deeply engaged in the intelligent transformation of heavy industry, with extensive experience across high-energy-consumption and high-emission sectors such as cement, petrochemicals, steel, and speciality chemicals. Its core solutions cover three main areas: intelligent production management, data-driven decision optimisation, and end-to-end energy saving and emission reduction. By integrating advanced AI algorithms with industrial IoT, Grand Founts provides comprehensive services ranging from production process optimisation to precise carbon emission control.',
    extLayout: 'Extended Layout: One-Stop Environmental Service Chain',
    extLayoutText: 'Beyond its AI-driven core business, the company has also expanded into the environmental protection industry chain. Services include industrial filter bag R&D and manufacturing, intelligent environmental management systems, equipment safety anomaly alerts, real-time quality prediction, process parameter optimisation, as well as filter bag sales and after-sales maintenance.',
    accreditations: 'Accreditations and Honours',
    accreditationsText: 'Thanks to its strong technical capabilities and market performance, the company has received multiple authoritative certifications and honours:',
    li1: 'Technology Enterprise Recognition: Certified as a Technology-Based SME of Shandong Province by the Shandong Provincial Department of Science and Technology.',
    li2: 'Credit System Certification: Selected by the Credit Rating and Certification Centre of the Chinese Academy of International Trade and Economic Cooperation under the Ministry of Commerce as a Credit Certified Enterprise.',
    li3: 'Intellectual Property Protection: Proprietary systems such as the AI-Based Equipment Fault Early Warning System and the AI-Based Production Energy Consumption Control System have been granted national software copyrights.',
    li4: 'Innovation Track Breakthrough: Successfully shortlisted for the 14th China Innovation and Entrepreneurship Competition (National Finals in Next-Generation Information Technology).',
    mission: 'Mission',
    coreValues: 'Core Values',
    techCore: 'Technical Core',
    valueProposition: 'Value Proposition',
    coreTeam: 'Core Team',
    values: {
      innovation: 'Innovation-Driven',
      innovationText: 'Our team is dedicated to integrating cutting-edge AI technology into industrial practice, driving digital transformation.',
      sustainability: 'Sustainability',
      sustainabilityText: 'We are committed to creating long-term value for businesses and society.',
      expertise: 'Expertise & Passion',
      expertiseText: 'We provide every team member with a platform to unleash creativity and broad career development opportunities.'
    },
    techValues: {
      ai: 'AI Algorithms',
      aiText: 'Proprietary data optimisation algorithms.',
      sensor: 'Sensor Networks',
      sensorText: 'Multi-point equipment data collection.',
      monitor: 'Real-Time Monitoring',
      monitorText: 'Intelligent, data-driven control.'
    },
    missionValues: {
      innovation: 'Innovation',
      innovationText: 'Advancing ESG in heavy industry through AI technology.',
      results: 'Significant Results',
      resultsText: 'Achieving net-zero carbon and sustainability for enterprises.'
    },
    propositionValues: {
      cost: 'Cost Savings',
      costText: 'High energy efficiency with low capital expenditure.',
      efficiency: 'Efficiency Improvement',
      efficiencyText: 'Smarter operations, improved overall performance.',
      risk: 'Risk Reduction',
      riskText: 'Optimise energy use and minimise downtime and critical risks.'
    }
  },

  // ===== Contact page =====
  contact: {
    pageTitle: 'Contact Us',
    description: 'Want to learn more about our products and solutions? Feel free to contact us at service@grandfounts.com, or call us: +86-0633-8179588, or fill out the form below:',
    name: 'Name (Required)',
    phone: 'Phone (Required)',
    email: 'Email (Required)',
    company: 'Company Name',
    address: 'Company Address',
    other: 'Other',
    submit: 'Submit',
    namePlaceholder: 'Please enter your name',
    phonePlaceholder: 'Please enter your contact number',
    emailPlaceholder: 'Please enter your email',
    companyPlaceholder: 'Please enter company name',
    addressPlaceholder: 'Please enter company address',
    otherPlaceholder: 'Additional information',
    submitSuccess: 'Form submitted successfully!',
    submitFail: 'Submission failed: '
  },

  // ===== Honor list =====
  honor: {
    honorType: 'Honours',
    softwareType: 'Software Copyrights',
    competitionType: 'Competition Awards'
  }
}
